export const FETCH_USERROLESLIST_REQUEST = "FETCH_USERROLESLIST_REQUEST";
export const FETCH_USERROLESLIST_SUCCESS = "FETCH_USERROLESLIST_SUCCESS";
export const FETCH_USERROLESLIST_FAILURE = "FETCH_USERROLESLIST_FAILURE";
